import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import RegisterPage1 from "./RegisterPage1";
import RegisterPage2 from "./RegisterPage2";
import RegisterPage3 from "./RegisterPage3";
import RegisterPage4 from "./RegisterPage4";
import background from "../../assets/background.jpg";
import Footer from "../../components/Footer";
import SimpleHeader from "../../assets/SimpleHeader";

const RegisterForm = ({ isEmbedded = false }) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  const handleNext = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
    setStep((prev) => prev + 1);
  };

  const handlePrevious = () => setStep((prev) => prev - 1);
  const handleFinalSubmit = (data) => {
    /* Submit logic */
  };

  const token = localStorage.getItem("token");
  const onGoLogin = () => navigate("/");

  // When embedded or logged in (token exists), show minimal layout; when standalone, show full page
  if (isEmbedded || token) {
    return (
      <div className="w-full">
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="w-full"
        >
          {/* Form Content */}
          {step === 1 && (
            <RegisterPage1 
              formData={formData}
              onNext={handleNext} 
              onDataChange={(data) => setFormData(prev => ({ ...prev, ...data }))}
            />
          )}
          {step === 2 && (
            <RegisterPage2 
              formData={formData}
              onSubmit={handleNext} 
              onPrevious={handlePrevious}
              onDataChange={(data) => setFormData(prev => ({ ...prev, ...data }))}
            />
          )}
          {step === 3 && (
            <RegisterPage3 
              formData={formData}
              onSubmit={handleNext} 
              onPrevious={handlePrevious}
              onDataChange={(data) => setFormData(prev => ({ ...prev, ...data }))}
            />
          )}
          {step === 4 && (
            <RegisterPage4
              formData={formData}
              onSubmit={handleFinalSubmit}
              onPrevious={handlePrevious}
              onDataChange={(data) => setFormData(prev => ({ ...prev, ...data }))}
            />
          )}
        </motion.div>
      </div>
    );
  }

  // Standalone page layout with header, background, and footer
  return (
    <div
      className="min-h-screen flex flex-col bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Professional Header */}
      <SimpleHeader onLogoClick={onGoLogin} />

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center px-4 py-6">
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="w-full max-w-5xl"
        >
          {/* Form Content */}
          {step === 1 && (
            <RegisterPage1 
              formData={formData}
              onNext={handleNext} 
              onDataChange={(data) => setFormData(prev => ({ ...prev, ...data }))}
            />
          )}
          {step === 2 && (
            <RegisterPage2 
              formData={formData}
              onSubmit={handleNext} 
              onPrevious={handlePrevious}
              onDataChange={(data) => setFormData(prev => ({ ...prev, ...data }))}
            />
          )}
          {step === 3 && (
            <RegisterPage3 
              formData={formData}
              onSubmit={handleNext} 
              onPrevious={handlePrevious}
              onDataChange={(data) => setFormData(prev => ({ ...prev, ...data }))}
            />
          )}
          {step === 4 && (
            <RegisterPage4
              formData={formData}
              onSubmit={handleFinalSubmit}
              onPrevious={handlePrevious}
              onDataChange={(data) => setFormData(prev => ({ ...prev, ...data }))}
            />
          )}
        </motion.div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default RegisterForm;